export default "__VITE_ASSET__h5k5830k__"